import { axiosInstance as axios } from "./axiosInstance";

export const requestStorage = ({
  method,
  apiConfigs,
  params,
  data,
  onSuccess,
}) => {
  const { scensumBaseUrl } = apiConfigs;

  return axios({
    method,
    url: `${scensumBaseUrl}/api/v1/classicguideengine/storage`,
    params,
    data,
  })
    .then((response) => {
      if (response.data === null) {
        console.error(
          `response.data is null for response: ${JSON.stringify(response)}`
        );
        return null;
      }

      if (
        method === "post" &&
        params &&
        params.Key &&
        response.data !== params.Key
      ) {
        console.error(
          `Unexpected response.data in response: ${JSON.stringify(
            response
          )} -- response.data !== params.Key`
        );
        return null;
      }

      return onSuccess(response);
    })
    .catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.error(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error", error.message);
      }
      console.error(error.config);
    });
};
